import React from 'react'
import { Provider } from 'react-redux'
import { Route, BrowserRouter as Router } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import Exchanger from './components/Exchanger/exchanger'
import MobileExchanger from './components/MobileExchenger/MobileExchanger'
import MobileSell from './components/MobileSell/MobileSell'
import MobileBuy from './components/MobileBuy/MobileBuy'
import MobileCheck from './components/MobileCheck/mobileCheckMain'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import PublicOrderHistory from './components/PublicOrderHistory/publicOrderHistory'
import BackEndInvoice from './components/Invoice/invoice'
import store from './redux/index'
import MobileExchangerOrder from './components/MobileExchenger/orderScreen/orderScreen'
import classes from './components/MobileExchenger/MobileExchanger.module.css'

import classes1 from './components/Error/errorScreen.module.css'

import { strings } from './i18n'
import Icon from './components/elements/Icon/Icon'

import config from './config/environment'

import AdminRouter from './components/Admin/adminRouter';


Sentry.init({ 
    dsn: config.dsn,
    
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.2,

    beforeBreadcrumb(breadcrumb, hint) {
        return breadcrumb.category === "ui.click" ? null : breadcrumb;
      },
});

const ErrorFallback = ({ error }) => {
    return (
        <>
            <div className={classes1.wrapper}>
                <div className={classes1.title}>{strings('errorScreen.title')}</div>
                <div className={classes1.description}>
                    {config.showError ?
                        `${window.location.pathname} ${error.message}`
                        :
                        strings('errorScreen.description')}
                </div>
                <div className={classes1.circleWrapper}>
                    <div>
                        <div className={classes1.circle} onClick={() => {
                            window.ReactNativeWebView.postMessage(JSON.stringify({ 'close': true }))
                        }}>
                            <Icon icon={'ARROW_BACK'} size={30} color={'#F5F5F5'} style={{ marginTop: 12 }} />
                        </div>
                        <div className={classes1.btn}>{strings('errorScreen.home')}</div>
                    </div>
                    <div>
                        <div className={classes1.circle}>
                            <a href={'https://t.me/trustee_support_bot?start=app'}>
                                <Icon icon={'SUPPORT'} size={30} color={'#F5F5F5'} style={{ marginTop: 12 }} />
                            </a>
                        </div>
                        <div className={classes1.btn}>{strings('errorScreen.support')}</div>
                    </div>
                </div>
            </div>
        </>
    )
}


function App() {
    return (
        <div style={window.location.pathname.indexOf('/skr') >= 0 ? {minHeight: '100vh', display: 'flex', flexDirection: 'column'} : null}>
            <Provider store={store}>
                <Router>
                    {window.location.pathname.indexOf('/mobile') ? <Header /> : null}
                    <Route exact path="/" component={Exchanger} />
                    <Route path="/skr" component={AdminRouter} />
                    <Sentry.ErrorBoundary fallback={ErrorFallback}>
                        <>
                            <Route path={'/mobile-exchanger'} component={MobileExchanger} />
                            <Route path={'/mobile-order-status'} component={MobileExchangerOrder} />
                            <Route path={'/mobile-sell'} component={MobileSell} />
                            <Route path={'/mobile-buy'} component={MobileBuy} />
                            <Route path={'/mobile-check'} component={MobileCheck} />
                        </>
                    </Sentry.ErrorBoundary>
                    <Route path="/backend-invoice" component={BackEndInvoice} />
                    <Route path="/order-history" component={PublicOrderHistory} />
                    {window.location.pathname.indexOf('/mobile') ?
                        <div className={window.location.pathname.indexOf('/order-history') ? '' : classes.footer} >
                            <Footer />
                        </div>
                        : null}
                </Router>
            </Provider>
        </div>
    )
}

export default withTranslation()(App)
